package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px

// SECTION PRINCIPALE PRICE
val PriceSectionContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(top = 30.px, bottom = 30.px, leftRight = 40.px)
    }
    Breakpoint.MD {
        Modifier.padding(top = 45.px, bottom = 50.px, leftRight = 60.px)
    }
    Breakpoint.LG {
        Modifier.padding(top = 60.px, bottom = 170.px, leftRight = 0.px)
    }
}

val PriceTitleStyle = CssStyle {
    base {
        Modifier
            .padding(bottom = 30.px)
            .fontSize(24.px)
            .fontFamily(INTER)
    }
    Breakpoint.MD {
        Modifier
            .padding(bottom = 45.px)
            .fontSize(28.px)
    }
    Breakpoint.LG {
        Modifier
            .padding(bottom = 100.px)
            .fontSize(32.px)
    }
}

// PRICING CARD
val PricingCardContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(15.px)
    }
    Breakpoint.MD {
        Modifier
            .width(320.px)
            .padding(20.px)
    }
    Breakpoint.LG {
        Modifier
            .width(380.px)
            .padding(30.px)
    }
}

val BillingInfoStyle = CssStyle {
    base { Modifier.margin(bottom = 20.px) }
    Breakpoint.MD { Modifier.margin(bottom = 30.px) }
}

val PriceRowStyle = CssStyle {
    base { Modifier.margin(bottom = 30.px) }
    Breakpoint.MD { Modifier.margin(bottom = 50.px) }
}

val PriceTextStyle = CssStyle {
    base { Modifier.fontSize(26.px) }
    Breakpoint.MD { Modifier.fontSize(30.px) }
    Breakpoint.LG { Modifier.fontSize(35.px) }
}

val PriceSubtextStyle = CssStyle {
    base { Modifier.fontSize(13.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
}

val PricingButtonStyle = CssStyle {
    base {
        Modifier
            .height(48.px)
            .fontSize(18.px)
            .margin(bottom = 40.px)
    }
    Breakpoint.MD {
        Modifier
            .height(52.px)
            .fontSize(20.px)
            .margin(bottom = 60.px)
    }
    Breakpoint.LG {
        Modifier
            .height(56.px)
            .fontSize(25.px)
    }
}

// FEATURE ITEM
val FeatureIconStyle = CssStyle {
    base { Modifier.fontSize(10.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
}

val FeatureTextStyle = CssStyle {
    base { Modifier.fontSize(13.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
}